import { useEffect } from 'react'
import { Modal } from './Modal';
import { type_WISHLIST_DASHBOARD_STATE } from '../types'

const selectors = {
  returnToSelector: '.js-return-to'
}

declare var wishlistDashboardState: type_WISHLIST_DASHBOARD_STATE

export function AccountSlideout({ children }: { children: any }) {
  useEffect(() => {
    const handleOpenAccountSlideout = () => {
      const returnToEls = Array.prototype.slice.call(document.querySelectorAll(selectors.returnToSelector))
      if (returnToEls.length > 0) {
        returnToEls.forEach((el: HTMLInputElement) => {
          el.value = sessionStorage.getItem('returnTo') || '/'
        })
      }
    }

    document.addEventListener('open-account-slideout', handleOpenAccountSlideout)

    return () => {
      document.removeEventListener('open-account-slideout', handleOpenAccountSlideout)
    }
  }, [])

  return (
    <Modal
      type='slideout'
      id="account-slideout"
      className="modal-account top-auto"
      heading={wishlistDashboardState.wishlist}
      content={<div className="w-full" dangerouslySetInnerHTML={{ __html: children.innerHTML }}></div>}
    />
  );
}
